export var ConfirmationModalType;
(function (ConfirmationModalType) {
    ConfirmationModalType["DELETE"] = "DELETE";
    ConfirmationModalType["EDIT"] = "EDIT";
})(ConfirmationModalType || (ConfirmationModalType = {}));
//# sourceMappingURL=confirmationModal.js.map